import Vue from 'vue'
import {onError} from 'apollo-link-error'
import {ApolloLink, Observable} from 'apollo-link'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {ApolloClient} from 'apollo-client'
import VueApollo from 'vue-apollo'
import {setContext} from 'apollo-link-context'
import {refreshTokenOrRedirectToLogin, refreshTokenOrFail} from '@/scripts/auth-utils'
import {clientId, clientType} from '@/scripts/utils'
import {backendURL} from '@/scripts/globals'

Vue.use(VueApollo)

const authLink = onError(({graphQLErrors, networkError, operation, forward}) => {
    if (graphQLErrors) {
        for (let err of graphQLErrors)
            if (err.extensions && err.extensions.category === 'not_authenticated')
                return new Observable(observer => {
                    refreshTokenOrRedirectToLogin(apolloClient)
                        .then(() => {
                            operation.setContext(({headers = {}}) => ({
                                headers: {
                                    ...headers,
                                    authorization: `JWT ${localStorage.getItem('accessToken')}`,
                                }
                            }))
                        })
                        .then(() => {
                            const subscriber = {
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            }

                            forward(operation).subscribe(subscriber)
                        })
                        .catch(error => {
                            observer.error(error)
                        })
                })
    }
    if (networkError)
        console.log(`[Network error]: ${networkError}`);
})
const authLink2 = setContext((_, {headers, ...context}) => {
    const token = localStorage.getItem('accessToken');
    return {
        headers: {
            ...headers,
            ...(token ? {authorization: `JWT ${token}`} : {}),
        },
        ...context,
    };
});

const httpLink = createHttpLink({
    uri: backendURL + '/graphql',
    headers: {
        'Client-Id': clientId,
        'Client-Type': clientType
    }
})

const link = ApolloLink.from([
    authLink,
    authLink2,
    httpLink
]);
const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
    link: link,
    cache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'no-cache'
        },
        query: {
            fetchPolicy: 'no-cache' // 'network-only'
        },
    }
})

const cache2 = new InMemoryCache()

// same as simple auth link but throws error instead redirect to login
const optionalAuthLink = onError(({graphQLErrors, networkError, operation, forward}) => {
    if (graphQLErrors) {
        for (let err of graphQLErrors)
            if (err.extensions && err.extensions.category === 'not_authenticated')
                return new Observable(observer => {
                    refreshTokenOrFail(apolloClient)
                        .then(() => {
                            operation.setContext(({headers = {}}) => ({
                                headers: {
                                    ...headers,
                                    authorization: `JWT ${localStorage.getItem('accessToken')}`,
                                }
                            }))
                        })
                        .then(() => {
                            const subscriber = {
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            }

                            forward(operation).subscribe(subscriber)
                        })
                        .catch(error => {
                            observer.error(error)
                        })
                })
    }
    if (networkError)
        console.log(`[Network error]: ${networkError}`);
})

const linkOptionalAuth = ApolloLink.from([
    optionalAuthLink,
    authLink2,
    httpLink
]);

export const apolloClientOptionalAuth = new ApolloClient({
    link: linkOptionalAuth,
    cache: cache2,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'no-cache'
        },
        query: {
            fetchPolicy: 'no-cache' // 'network-only'
        },
    }
})

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
})
